import { updateLocation } from 'src/components/enterprise/features/Locations/api/locationsApi';
import { ILocation } from 'src/types/Location';
import { SHORT_SEARCH_DELAY } from 'src/utilities/useSearchHooks';
import { pushError, pushSuccess } from 'src/utilities/notifications';

export interface UseUpdateLocationReturn {
  updateExistingLocation: (
    locationId: string,
    locationData: Partial<ILocation>
  ) => Promise<void>;
}

export interface UseUpdateLocationProps {
  corpId: string;
  onSuccess: () => void;
}

export const useUpdateLocation = ({
  corpId,
  onSuccess,
}: UseUpdateLocationProps): UseUpdateLocationReturn => {
  async function updateExistingLocation(
    locationId: string,
    locationData: Partial<ILocation>
  ): Promise<void> {
    try {
      await updateLocation({
        corpId,
        locationId,
        updatedLocation: locationData,
      });
      await new Promise<void>((resolve) => {
        setTimeout(() => {
          onSuccess();
          pushSuccess('Your location was updated');
          resolve();
        }, SHORT_SEARCH_DELAY);
      });
    } catch (error) {
      pushError(`Your location was not updated. Try again.`);
    }
  }

  return {
    updateExistingLocation,
  };
};
